import { ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import { getErrorStatus, getOperationCode } from 'store/selectors'
import { disableMixPanelTracking } from '../disable'

export const mapStateToMPEvent = (eventName, state) => { // (eventName: string, state: State)
  const errorName = (getErrorStatus(state) === 404)
    ? 'Static ressources are not available'
    : 'Unavailable Sale Content'

  return {
    'Error Code': getErrorStatus(state),
    'Error Name': errorName,
    'Error Page Source': 'Sales homepage',
    'Event Name': eventName,
    'Operation Code': getOperationCode(state),
    'Page Name': 'Technical Error Page'
  }
}

/*
** Handles the same errors as src/App/Main/Error/Technical
*/
const technicalErrorEpic = (actions$, state$) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(
    Actions.resources.EMPTY_SALE_RESOURCES_ERROR,
    Actions.resources.FETCH_RESOURCE_ERROR,
    Actions.version.FETCH_VERSION_ERROR
  ),
  tap(() => { // (action: EmptySaleResourcesAction || FetchResourceErrorAction || FetchVersionErrorAction)
    const eventName = 'Technical Error'

    track(eventName, mapStateToMPEvent(eventName, state$.value), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default technicalErrorEpic
